import api from "tools/api";
import { EndpointList } from "tools/config";
import {
  NumberLoginPostInterface,
  SessionCreateInterface,
  SessionRegisterPostInterface,
} from "./types";

export const AuthService = api.injectEndpoints({
  endpoints: (build) => ({
    createRegister: build.mutation<
      SessionCreateInterface,
      SessionRegisterPostInterface
    >({
      query: (data) => {
        const formData = new FormData();
        formData.append("email", data.email);
        formData.append("password", data.password);
        formData.append("fname", data.full_name);
        formData.append("lname", data.last_name);
        formData.append("password_confirmation", data.confirm_password);
        formData.append("dob", "1990-09-09");
        formData.append("phone", data.contact);

        return {
          url: EndpointList.REGISTER,
          method: "POST",
          body: formData,
        };
      },
      invalidatesTags: [EndpointList.REGISTER],
    }),
    createSession: build.mutation<any, any>({
      query: (data) => {
        const formData = new FormData();
        formData.append("email", data.email);
        formData.append("password", data.password);
        if (data.loginType != null)
          formData.append("loginType", data.loginType);
        return {
          url: EndpointList.LOGIN,
          method: "POST",
          // redirect: 'follow',
          body: formData,
        };
      },
      invalidatesTags: [EndpointList.LOGIN],
    }),
    verifyLoginOtp: build.mutation<any, any>({
      query: (data) => {
        const formData = new FormData();
        if (data?.phone) formData.append("phone", data.phone);
        if (data?.email) formData.append("email", data.email);
        formData.append("otp", data.otp);
        return {
          url: EndpointList.VERIFY_OTP,
          method: "POST",
          body: formData,
        };
      },
      invalidatesTags: [EndpointList.VERIFY_OTP],
    }),
    resendOtp: build.mutation<NumberLoginPostInterface, string>({
      query: (data) => {
        const formData = new FormData();
        formData.append("email", data);
        return {
          url: EndpointList.RESEND_OTP,
          method: "POST",
          // redirect: 'follow',
          body: formData,
        };
      },
      invalidatesTags: [EndpointList.REQUEST_EMAIL_OTP],
    }),
    forGotPass: build.mutation<any, string>({
      query: (data) => ({
        url: EndpointList.FORGOTPASS,
        method: "POST",
        // redirect: 'follow',
        body: { email: data },
      }),
      invalidatesTags: [EndpointList.REQUEST_EMAIL_OTP],
    }),
  }),
  overrideExisting: false,
});

export const {
  useCreateSessionMutation,
  useVerifyLoginOtpMutation,
  useResendOtpMutation,
  useForGotPassMutation,
  useCreateRegisterMutation,
} = AuthService;
